'use client';

import type React from 'react';

import useSlideOutFlagLabels from 'src/components/job-slide-out/components/use-slide-out-flag-labels';

/**
 * Read-only customer-facing summary banner for the slide-out.
 * Renders only when the panel's subject has an active flag — the work order's
 * own rollup in WO mode, or (SAAS-815 AC#5) the roll-up across all of the
 * maintenance request's work orders in MR mode. The pill label stays
 * API-driven (the customer-facing flag name, now "Build Back Risk" to match
 * Figma); the title and body are static descriptive copy.
 */
const FlagSummaryBanner: React.FC = () => {
  const flagLabels = useSlideOutFlagLabels();

  if (flagLabels.length === 0) {
    return null;
  }

  return (
    <div className="flag-banner" role="status">
      {flagLabels.map((label) => (
        <div className="flag-banner__row" key={label}>
          <div className="flag-banner__pill">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M2 7.5C2 7.5 2.5 7 4 7C5.5 7 6.5 8 8 8C9.5 8 10 7.5 10 7.5V1.5C10 1.5 9.5 2 8 2C6.5 2 5.5 1 4 1C2.5 1 2 1.5 2 1.5L2 11"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>{label}</span>
          </div>
          <p className="flag-banner__title">Build back work may be needed</p>
          <p className="flag-banner__body">
            This may involve restoration work to return the property to its
            original condition after the repair is complete. Your coordinator
            will confirm scope before any build-back work begins.
          </p>
        </div>
      ))}
    </div>
  );
};

export default FlagSummaryBanner;
